import { useCallback, useEffect, useRef } from 'react';
import { call } from './api';
import type { PlexClient, PlexItem } from './plex';
import { prefsNow } from './prefs';

/** Trakt bijwerken vanuit de player (scrobbelen) en scores. */

interface Ids { tmdb?: number; imdb?: string; tvdb?: number }

export function guidIds(item: Pick<PlexItem, 'Guid'> | null | undefined): Ids {
  const ids: Ids = {};
  for (const g of item?.Guid ?? []) {
    const [scheme, value] = g.id.split('://');
    if (scheme === 'tmdb' && Number(value)) ids.tmdb = Number(value);
    else if (scheme === 'tvdb' && Number(value)) ids.tvdb = Number(value);
    else if (scheme === 'imdb' && value) ids.imdb = value;
  }
  return ids;
}

type Action = 'start' | 'pause' | 'stop';

/**
 * Geeft een functie die de kijkstand aan Trakt doorgeeft. Stuurt alleen bij een verandering
 * (start → pauze → stop), niet bij elke voortgangsmelding. Doet niets als het profiel het uit heeft staan.
 */
export function useTraktScrobble(_plex: PlexClient, item: PlexItem | null): (action: Action, progress: number) => void {
  const last = useRef<Action | null>(null);
  useEffect(() => {
    last.current = null;
  }, [item?.ratingKey]);

  // De server zoekt de id's zelf op in Plex en stuurt het naar Trakt en/of SIMKL (wat aan staat)
  return useCallback((action: Action, progress: number) => {
    const p = prefsNow();
    if (!item || (item.type !== 'movie' && item.type !== 'episode') || (!p.traktScrobble && !p.simklSync)) return;
    if (last.current === action) return;
    if (action === 'stop' && last.current === null) return; // nooit gestart
    last.current = action;
    void call('/api/sync/scrobble', { method: 'POST', body: JSON.stringify({ action, progress: Math.round(progress * 10) / 10, ratingKey: item.ratingKey }), keepalive: action === 'stop' }).catch(() => undefined);
  }, [item]);
}

export const traktRating = {
  get: (type: 'movie' | 'tv', tmdbId: number) => call<{ rating: number | null; linked: boolean }>(`/api/trakt/rating?type=${type}&tmdbId=${tmdbId}`),
  set: (type: 'movie' | 'tv', tmdbId: number, rating: number) => call<{ rating: number | null }>('/api/trakt/rating', { method: 'PUT', body: JSON.stringify({ type, tmdbId, rating }) }),
};
